import { dividerStyle } from './Divider.css';

export const Divider: React.FC = () => <div className={dividerStyle} />;
